import { render, staticRenderFns } from "./to-order.vue?vue&type=template&id=2cefeed2&"
import script from "./to-order.vue?vue&type=script&lang=js&"
export * from "./to-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports